<template>
  <div class="new-table-box">
    <div class="tip-total">
      <div v-for="(item, index) in tipList" :key="index" class="tip_item">
        <div class="green_bg">
          <svg t="1731742604806" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
            p-id="1589" width="35" height="35">
            <path
              d="M874.666667 553.877333V746.666667h-192v-128.021334h-64v258.986667h-64V554.666667h192v127.978666h64v-128.768h64zM469.333333 554.666667v320H149.333333V554.666667h320z m405.333334 256v64h-192v-64h192z m-469.333334-192h-192v192h192v-192z m-64 64v64h-64v-64h64z m128-533.333334v320H149.333333V149.333333h320z m405.333334 0v320H554.666667V149.333333h320z m-469.333334 64h-192v192h192v-192z m405.333334 0h-192v192h192v-192z m-469.333334 64v64h-64v-64h64z m405.333334 0v64h-64v-64h64z"
              fill="#ffffff" p-id="1590"></path>
          </svg>
        </div>
        <div class="total-r">
          <p>{{ item.total }}</p>
          <p>{{ item.name }}(元)</p>
        </div>
      </div>
    </div>

    <el-form inline ref="form" class="search-form common-box-search-form" label-position="right" :model="form"
      label-width="90px">
      <search-form @search="handleSearch" @refresh="handleRefresh">
        <div slot="content">
          <el-form-item label="统计类型：" prop="statisticaltype">
            <el-select size="mini" v-model="form.statisticaltype" filterable placeholder="请选择支出项" clearable
              @change="handleSearchListData">
              <el-option v-for="item in statisticaltypeList" :key="item.code" :label="item.name"
                :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="批次号：">
            <el-input @change="handleSearchListData" size="mini" v-model.trim="form.patchNo" placeholder="请输入应付单据号"
              clearable></el-input>
          </el-form-item>
          <el-form-item label="应付单据号：">
            <el-input @change="handleSearchListData" size="mini" v-model.trim="form.payableNo" placeholder="请输入应付单据号"
              clearable></el-input>
          </el-form-item>
          <el-form-item v-show="form.statisticaltype == 1" label="支出项：" prop="type">
            <el-select size="mini" v-model="form.type" filterable placeholder="请选择" clearable
              @change="handleSearchListData">
              <el-option v-for="item in spendingList" :key="item.code" :label="item.name" :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-show="form.statisticaltype == 2" label="应收类型：" prop="type">
            <el-select size="mini" v-model="form.type" filterable placeholder="请选择支出项" clearable
              @change="handleSearchListData">
              <el-option v-for="item in receiveTypeList" :key="item.code" :label="item.name"
                :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否付款：" prop="passStatus" v-show="form.statisticaltype == 1">
            <el-select size="mini" v-model="form.passStatus" filterable placeholder="请选择" clearable
              @change="handleSearchListData">
              <el-option v-for="item in passStatusList" :key="item.code" :label="item.name"
                :value="item.code"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="付款人:" v-show="form.statisticaltype == 1" prop="user" @change="handleSearchListData">
            <el-select size="mini" v-model="form.payUserId" filterable placeholder="请选择付款人" clearable value-key="userId">
              <el-option v-for="item in userList" :key="item.userId" :label="item.nickname"
                :value="item.userId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户:" v-show="form.statisticaltype == 2" prop="propertyUnit">
            <el-select size="mini" v-model="form.propertyUnitId" filterable placeholder="请选择客户" clearable
              @change="handleSearchListData">
              <el-option v-for="item in propertyUnitSimpleList" :key="item.id" :label="item.unitName"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间范围：">
            <el-date-picker v-model="form.createTimeBetween" @change="handleSearchListData" size="mini" type="daterange"
              range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss"
              unlink-panels clearable></el-date-picker>
          </el-form-item>

          <el-form-item label="维保员:" v-show="form.statisticaltype == 2" prop="repairUserId">
            <el-select size="mini" v-model="form.repairUserId" filterable placeholder="请选择客户" clearable
              @change="handleSearchListData">
              <el-option v-for="item in userList" :key="item.userId" :label="item.nickname"
                :value="item.userId"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </search-form>
    </el-form>

    <div class="new-table-cont">
      <div class="btns__container">
        <!-- <el-button size="mini" type="primary" class="plr28" @click="handleAdd">添加</el-button>
        <el-button size="mini" type="primary" class="plr28" @click="handleDelete" plain>删除
        </el-button> -->
      </div>
      <div class="table__container" style="height: calc(100% - 65px);">
        <el-table v-loading="tableLoading" :data="list" height="100%" border style="width: 100%"
          :summary-method="getSummaries" show-summary v-show="form.statisticaltype == 1"
          @selection-change="handleSelectionChange">
          <el-table-column type="index" prop="id" label="序号" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="payableNo" label="应付单据号" width="180"></el-table-column>
          <el-table-column show-overflow-tooltip prop="billDate" label="单据日期" width="160"></el-table-column>
          <el-table-column show-overflow-tooltip prop="typeName" label="财务支出项目" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="money" sortable label="付款金额" width="90">
            <template slot-scope="scope">
              <div style="color: red;font-size: 16px;font-weight: 600;">
                {{ scope.row.money }}
              </div>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="passStatusName" label="是否付款" width="90"></el-table-column>
          <el-table-column show-overflow-tooltip prop="cardCode" label="卡号" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="payUserName" label="收款人" width="120"></el-table-column>
          <el-table-column show-overflow-tooltip prop="remark" label="备注" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="createTime" label="创建日期" width="160"></el-table-column>
          <el-table-column show-overflow-tooltip prop="patchNo" label="批次号" width="280"></el-table-column>
        </el-table>


        <el-table v-loading="tableLoading" :data="list" height="100%" border style="width: 100%" show-summary
          :summary-method="getSummaries" v-show="form.statisticaltype == 2" @selection-change="handleSelectionChange">
          <el-table-column type="index" prop="id" label="序号" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="propertyUnitName" label="客户名称" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="inMoney" sortable label="应收总金额" width="100">
            <template slot-scope="scope">
              <div style="color: red;font-size: 16px;font-weight: 600;">
                {{ scope.row.inMoney }}
              </div>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="receiveMoney" sortable label="已收金额" width="100">
            <template slot-scope="scope">
              <div style="color: red;font-size: 16px;font-weight: 600;">
                {{ scope.row.receiveMoney }}
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column show-overflow-tooltip prop="receiveNo" label="应收单据号" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="typeName" label="应收类型" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="remark" label="备注" width="200"></el-table-column> -->

          <el-table-column show-overflow-tooltip prop="residualProfit" label="利润" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="proMoney" label="配件费" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="personMoney" label="人工" width="200"></el-table-column>
          

          <el-table-column show-overflow-tooltip prop="createTime" label="创建日期" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="patchNo" label="批次号" width="260"></el-table-column>
          <el-table-column label="操作" width="140px" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="handleCollectionList(scope.row)">收款详情</el-button>
              <el-button size="mini" type="text" @click="handleReceiveReminderList(scope.row)">催收详情</el-button>
              <!-- <el-button size="mini" type="text" v-if="scope.row.passStatus == 1"
                @click="handlePass(scope.row)">确认付款</el-button>
              <div class="btn-divide"></div>
              <el-button size="mini" type="text" v-if="scope.row.passStatus == 1"
                @click="handleEdit(scope.row)">编辑</el-button>
              <div class="btn-divide"></div>
              <el-button size="mini" type="text" @click="handleDeleteCause(scope.row)">删除
              </el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog title="催收详情" :visible.sync="dialogTableVisible" width="70%">
        <el-table :data="receiveList" height="60vh" border style="width: 100%" :row-class-name="tableRowClassName">
          <el-table-column show-overflow-tooltip type="index" prop="" label="序号" width="50"></el-table-column>
          <el-table-column show-overflow-tooltip prop="typeName" label="应收类型" width="80"></el-table-column>
          <el-table-column show-overflow-tooltip prop="inMoney" label="应收总金额" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="receiveMoney" label="已收金额" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="notReceiveMoney" label="未收金额" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="invoiceMoney" label="开票金额" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="reminderAmount" label="催缴次数" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="overStatusName" label="应收状态" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="overDayAmount" label="逾期天数" width="80">
            <!-- <template slot-scope="scope">
              <el-button size="mini" type="text" @click="handleShow(scope.row)">{{ scope.row.sourceCode }}</el-button>
            </template> -->
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="sourceCode" label="关联单号" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="liftInfo" label="相关电梯" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="repairUserName" label="维保人员" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="passStatusName" label="是否收款" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="passDate" label="收款时间" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="remark" label="备注" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="createTime" label="创建时间" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="receiveNo" label="应收单据号" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="billDate" label="单据日期" width="200"></el-table-column>
          <!-- <el-table-column label=" " prop=" "></el-table-column>
          <el-table-column label="操作" width="98px" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="handleReminderList(scope.row)">催款</el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </el-dialog>
      <collection-list v-if="collectionListVisible" :detail="causeDetail" @cancel="collectionListVisible = false"
        @confirm="handleCollectionListVisibleConfirm">
      </collection-list>
      <div class="pagenation__container">
        <div class="for-fff-bg">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex"
            :page-sizes="[25, 50, 100, 150, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="total"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


import { getPayableList, deletePayable, passPayable, userSimpleList, collectPayableList } from '@/api/Payable'
import { getReminderPageList, getReceiveTypeList, getPropertyUnitSimpleList } from '@/api/Receive'
import { getSpendingList } from '@/api/Spending'

import AddCause from './components/AddCause'
import EditCause from './components/EditCause'
import CollectionList from './components/CollectionList'
export default {
  name: 'MaterialInfo',
  components: {
    AddCause,
    EditCause,
    CollectionList
  },
  data() {
    return {
      form: {
        createTimeBetween: null,
        payableNo: "",
        statisticaltype: '1',
        propertyUnitId: '',
      },
      tableLoading: false,
      list: [
        {
          id: 1,
          money: "100",
        }
      ],
      multipleSelection: [],
      pageIndex: 1,
      pageSize: 50,
      total: 0,
      addCauseVisible: false,
      editCauseVisible: false,
      checkDepartment: false,
      causeDetail: {},
      spendingList: [],
      userList: [],
      tipList: [
        {
          "name": "本月收款总额",
          "total": 0
        }, {
          "name": "本月付款总额",
          "total": 0
        }, {
          "name": "历史收款总额",
          "total": 0
        }, {
          "name": "历史付款总额",
          "total": 0
        },
        {
          "name": "本月维修总额",
          "total": 0
        }, {
          "name": "本月维保总额",
          "total": 0
        }

      ],
      statisticaltypeList: [
        {
          name: '应付汇总',
          code: '1',
        },
        {
          name: '应收汇总',
          code: '2',
        }
      ],
      passStatusList: [
        {
          name: '是',
          code: 10,
        },
        {
          name: '否',
          code: 1,
        }
      ],
      propertyUnitSimpleList: [],
      receiveTypeList: [],
      dialogTableVisible: false,
      collectionListVisible: false,
      receiveList: [],
      receiveRemindParam: {
        pageIndex: 1,
        pageSize: 500,
        propertyUnitId: ''
      }
    }
  },
  computed: {
    hasRole: function () {
      return this.$store.getters['common/promise/getRole'](this.$route.path);
    }
  },
  created() {
    this.getListData();
    this.handleSpendingList();
    this.handleUserSimpleList();
    this.handleSpendingList222();
    this.handlePropertyUnitSimpleList();
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (row.overDayAmount >= 30) {
        return 'warning-row'
      } else if (row.overDayAmount >= 10) {
        return 'oldlace';
      } else {
        return 'success-row';
      }
    },
    async handleUserSimpleList() {
      const res = await userSimpleList({});
      if (res.code === 200) {
        this.total = res.data.total
        this.userList = res.data
      }
    },
    async handleSpendingList() {
      const res = await getSpendingList();
      if (res.code === 200) {
        this.total = res.data.total
        this.spendingList = res.data
      }
    },
    async getListData() {
      this.tableLoading = true
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      for (let key in this.form) {
        if (this.form[key])
          params[key] = this.form[key]
      }
      if (this.form.createTimeBetween) {
        delete params.createTimeBetween;
        params.billDateEnd = this.form.createTimeBetween[1];
        params.billDateStart = this.form.createTimeBetween[0];
      }
      const res = await collectPayableList(params)
      if (res.code === 200) {
        console.log("acd", res);
        //本月收款总金额
        this.tipList[0].total = res.data.monthReceiveMoney

        //本月付款总额
        this.tipList[1].total = res.data.monthPayableMoney

        //历史收款总额
        this.tipList[2].total = res.data.yearReceiveMoney

        //历史付款总额
        this.tipList[3].total = res.data.yearPayableMoney

        //本月维修总额
        this.tipList[4].total = res.data.monthRepairMoney

        //本月维保总额
        this.tipList[5].total = res.data.monthMaintenanceMoney

        this.total = res.data.total
        this.list = res.data.list
      }
      this.tableLoading = false
    },
    handleSearch() {
      this.pageIndex = 1
      this.getListData()
    },
    handleRefresh() {
      for (let key in this.form) {
        if (Array.isArray(this.form[key])) {
          this.form[key] = []
        } else {
          this.form[key] = ''
        }
      }
      this.form.statisticaltype = '1'
      this.pageIndex = 1
      this.getListData()
    },
    handleSearchListData() {
      this.pageIndex = 1
      this.getListData()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleDeleteCause(row) {
      const idList = [row.id]
      this.deletePayable(idList)
    },
    handleCheck(row) {
      this.causeDetail = row
      this.checkDepartment = true
    },
    handleEdit(row) {
      this.causeDetail = row
      this.editCauseVisible = true
    },

    handleCollectionList(row) {
      this.causeDetail = row
      this.collectionListVisible = true
    },

    handleReceiveReminderList(row) {
      this.dialogTableVisible = true
      this.receiveRemindParam.propertyUnitId = row.propertyUnitId
      this.getReceiveRemindListData()
    },


    async getReceiveRemindListData() {
      this.tableLoading = true;
      const res = await getReminderPageList(this.receiveRemindParam);
      if (res.code === 200) {
        console.log("ccc", res);
        this.receiveList = res.data.list[0].receiveList;
      }
      this.tableLoading = false;
    },


    handleDelete() {
      if (!this.multipleSelection.length) {
        this.$message.warning('请选择要删除的行')
        return
      }
      const idList = this.multipleSelection.map(item => item.id)
      this.deletePayable(idList)
    },
    deletePayable(idList) {
      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await deletePayable({
          idList
        })
        if (res.code === 200) {
          this.$message.success('删除成功')
          this.getListData()
        }
      }).catch((err) => {
        console.log(err)
      })

    },
    handleAdd() {
      this.addCauseVisible = true
    },
    exportCause() {
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      for (let key in this.form) {
        if (this.form[key])
          params[key] = this.form[key]
      }
      exportCause(params)
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getListData()
    },
    handleCurrentChange(val) {
      this.pageIndex = val
      this.getListData()
    },
    handleAddCauseConfirm() {
      this.addCauseVisible = false
      this.pageIndex = 1
      this.getListData()
    },
    handleEditCauseConfirm() {
      this.editCauseVisible = false
      this.getListData()
    },
    handlePass(row) {
      const idList = [row.id];
      this.$confirm('确定审核通过?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await passPayable({
          idList
        })
        if (res.code === 200) {
          this.$message.success('审核成功')
          this.getListData()
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    async handlePropertyUnitSimpleList() {
      const res = await getPropertyUnitSimpleList({});
      if (res.code === 200) {
        this.propertyUnitSimpleList = res.data
      }
    },
    async handleSpendingList222() {
      const res = await getReceiveTypeList();
      if (res.code === 200) {
        this.receiveTypeList = res.data
      }
    },
    handleCollectionListVisibleConfirm() {
      this.collectionListVisible = false
      this.pageIndex = 1
      this.getListData()
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总价';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        console.log(column.property, 'column.property')
        if (!values.every(value => isNaN(value)) && (column.property == 'money' || column.property == 'receiveMoney' || column.property == 'inMoney')) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] += ' 元';
        } else {
          sums[index] = '';
        }
      });

      return sums;
    },
  }
}
</script>

<style lang="scss">
.new-table-box {
  padding: 10px;

  .tip-total {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;

    .tip_item {
      background: #fff;
      display: flex;
      padding: 5px;
      padding-right: 10px;
      margin-right: 10px;
      flex: 1;
    }

    .green_bg {
      width: 50px;
      height: 50px;
      background: orange;
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: 50px;
      margin-right: 10px;
    }

    .total-r {
      p:nth-of-type(1) {
        font-size: 20px;
        font-weight: 600;
      }
    }
  }

  .btns__container {
    margin-bottom: 0;
    margin: 10px 0;
  }

  .new-table-cont {
    position: relative;
    height: calc(100vh - 255px);

    .operation-and-table__container {
      top: 0px;
    }
  }
}
</style>
<style>
::deep(.el-table__footer-wrapper tbody td.el-table__cell) {
  font-weight: 600 !important;
}

.el-table .warning-row {
  background: #f19090;
}

.el-table .oldlace {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>


// WEBPACK FOOTER //
// src/pages/Collect/Collect.vue